// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Assessment Score Dashboard Styles - Qatar Gray Theme */
:root {
  --primary-color: #e2e8f0;
  --primary-light: #f1f5f9;
  --primary-dark: #cbd5e1;
  --secondary-color: hsl(159, 100%, 51%);
  --accent-color: hsl(159, 100%, 51%);
  --text-primary: #1e293b;
  --text-secondary: #475569;
  --text-muted: #64748b;
  --bg-primary: #f8fafc;
  --bg-secondary: #f1f5f9;
  --bg-tertiary: #e2e8f0;
  --success-color: #07ffa9;
  --warning-color: #1f7c50;
  --danger-color: #ef4444;
  --info-color: #07ffa9;
  --purple-color: #1f7c50;
  --gradient-primary: linear-gradient(135deg, rgba(7, 255, 169, 0.1) 0%, rgba(31, 124, 80, 0.15) 100%);
  --gradient-secondary: linear-gradient(135deg, #07ffa9 0%, #1f7c50 100%);
  --shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  --border-radius: 12px;
  --border-radius-lg: 16px;
  --transition: all 0.3s ease-in-out;
}

.assessment-score-page {
  min-height: 100vh;
  background: radial-gradient(circle at 0% 0%, rgba(7, 255, 169, 0.05), transparent 55%),
              radial-gradient(circle at 100% 100%, rgba(31, 124, 80, 0.08), transparent 60%),
              #f1f5f9;
  padding: 1rem;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
  color: var(--text-primary);
}

/* Header Styles */
.assessment-header {
  text-align: center;
  margin-bottom: 2rem;
  padding: 2rem 0;
}

.assessment-header h1 {
  font-size: 2.5rem;
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 0.5rem;
  background: var(--gradient-secondary);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.assessment-header p {
  font-size: 1.1rem;
  color: var(--text-secondary);
  max-width: 600px;
  margin: 0 auto;
}

/* Tab Navigation */
.tab-navigation {
  display: flex;
  justify-content: center;
  gap: 0.5rem;
  margin-bottom: 2rem;
  background: var(--bg-primary);
  padding: 0.5rem;
  border-radius: var(--border-radius-lg);
  box-shadow: var(--shadow-md);
  border: 1px solid rgba(172, 203, 195, 0.15);
}

.tab-button {
  padding: 0.75rem 1.5rem;
  border: none;
  background: transparent;
  color: var(--text-secondary);
  font-weight: 500;
  border-radius: var(--border-radius);
  cursor: pointer;
  transition: var(--transition);
  font-size: 0.95rem;
}

.tab-button:hover {
  background: rgba(7, 255, 169, 0.1);
  color: var(--text-primary);
}

.tab-button.active {
  background: var(--gradient-secondary);
  color: #ffffff;
  box-shadow: 0 0 15px rgba(7, 255, 169, 0.3);
}

/* Assessment Content */
.assessment-content {
  max-width: 1400px;
  margin: 0 auto;
}

/* Assessment Sections */
.assessment-section {
  margin-bottom: 4rem;
}

.assessment-section:last-child {
  margin-bottom: 2rem;
}

.section-title {
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  background: linear-gradient(135deg, var(--secondary-color) 0%, var(--secondary-color)dd 100%);
  -webkit-background-clip: text;
 
  background-clip: text;
  position: relative;
  color: var(--secondary-color);
}



/* Assessment Grid */
.assessment-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 1.5rem;
  margin-bottom: 2rem;
}

/* Score Cards */
.score-card {
  background: #ffffff;
  border-radius: var(--border-radius-lg);
  padding: 2rem;
  box-shadow: var(--shadow-md);
  transition: var(--transition);
  border: 1px solid rgba(172, 203, 195, 0.2);
}

.score-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(7, 255, 169, 0.2);
  border-color: rgba(7, 255, 169, 0.4);
}

.score-card h3 {
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 1.5rem;
  text-align: center;
}

.main-score {
  grid-column: span 2;
  text-align: center;
}

.main-score h3 {
  font-size: 1.5rem;
  margin-bottom: 2rem;
}

/* Donut Chart */
.donut-chart {
  position: relative;
  display: inline-block;
  margin: 0 auto;
  width: fit-content;
  height: fit-content;
}

.objective-header .donut-chart {
  margin: 0;
}

.donut-label {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.donut-label .percentage {
  display: block;
  font-size: 2rem;
  font-weight: 700;
  color: var(--text-primary);
  line-height: 1;
}

.donut-label .label {
  display: block;
  font-size: 0.875rem;
  color: var(--text-secondary);
  margin-top: 0.25rem;
}

/* Score Details */
.score-details {
  margin-top: 1.5rem;
}

.score-level {
  text-align: center;
}

.level-badge {
  display: inline-block;
  padding: 0.5rem 1rem;
  background: var(--gradient-secondary);
  color: #ffffff;
  border-radius: 20px;
  font-weight: 600;
  font-size: 0.875rem;
  margin-bottom: 0.5rem;
  box-shadow: 0 0 15px rgba(7, 255, 169, 0.3);
}

.score-level p {
  color: var(--text-secondary);
  margin: 0;
  font-size: 0.95rem;
}

/* Bar Chart */
.bar-chart {
  position: relative;
  padding: 1rem 0;
}

.bars {
  display: flex;
  align-items: end;
  justify-content: space-around;
  height: 100%;
  gap: 1rem;
}

.bar-group {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1 1;
  height: 100%;
}

.bar {
  width: 100%;
  max-width: 60px;
  border-radius: 6px 6px 0 0;
  position: relative;
  transition: var(--transition);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  min-height: 20px;
}

.bar:hover {
  transform: scale(1.05);
}

.bar-value {
  position: absolute;
  top: -25px;
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--text-primary);
}

.bar-label {
  margin-top: 0.5rem;
  font-size: 0.75rem;
  color: var(--text-secondary);
  text-align: center;
  transform: rotate(-45deg);
  white-space: nowrap;
  max-width: 80px;
}

/* Enhanced Bar Chart */
.bar-chart-enhanced {
  position: relative;
  display: flex;
  gap: 1rem;
  padding: 1rem;
  height: 100%;
}

.y-axis-labels {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
  padding-right: 0.75rem;
  min-width: 50px;
  height: 100%;
}

.y-axis-label {
  font-size: 0.75rem;
  color: var(--text-secondary);
  font-weight: 500;
}

.chart-area {
  flex: 1 1;
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.grid-lines {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  pointer-events: none;
  z-index: 0;
}

.grid-line {
  width: 100%;
  height: 1px;
  background: linear-gradient(to right, transparent, var(--primary-color) 5%, var(--primary-color) 95%, transparent);
  opacity: 0.3;
}

.bars-enhanced {
  position: relative;
  display: flex;
  align-items: flex-end;
  justify-content: space-around;
  height: 100%;
  gap: 1.5rem;
  padding: 0.5rem 0;
  z-index: 1;
}

.bar-group-enhanced {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1 1;
  height: 100%;
  max-width: 120px;
}

.bar-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  position: relative;
}

.bar-enhanced {
  width: 100%;
  max-width: 80px;
  min-width: 50px;
  border-radius: 8px 8px 0 0;
  position: relative;
  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  min-height: 30px;
  cursor: pointer;
  border: 2px solid transparent;
}

.bar-enhanced:hover {
  transform: translateY(-4px) scale(1.05);
  border-color: rgba(255, 255, 255, 0.3);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15) !important;
}

.bar-value-enhanced {
  position: absolute;
  top: -28px;
  font-size: 0.875rem;
  font-weight: 700;
  color: var(--text-primary);
  background: var(--bg-primary);
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  box-shadow: var(--shadow-sm);
  white-space: nowrap;
  opacity: 0;
  transition: opacity 0.3s ease;
  z-index: 10;
}

.bar-enhanced:hover .bar-value-enhanced {
  opacity: 1;
}

.bar-label-enhanced {
  margin-top: 0.75rem;
  font-size: 0.8rem;
  color: var(--text-primary);
  text-align: center;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  line-height: 1.2;
}

/* Line Chart */
.line-chart {
  position: relative;
  padding: 1rem;
}

.line-labels {
  display: flex;
  justify-content: space-between;
  margin-top: 0.5rem;
}

.line-label {
  font-size: 0.75rem;
  color: var(--text-secondary);
  text-align: center;
}

/* Enhanced Line Chart */
.line-chart-enhanced {
  position: relative;
  display: flex;
  gap: 1.25rem;
  padding: 1.5rem 1rem;
  height: 100%;
  background: linear-gradient(to bottom, transparent, var(--bg-secondary) 100%);
  border-radius: var(--border-radius);
}

.y-axis-labels-line {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
  padding-right: 1rem;
  min-width: 55px;
  height: 100%;
}

.y-axis-label-line {
  font-size: 0.8rem;
  color: var(--text-secondary);
  font-weight: 600;
  letter-spacing: 0.5px;
}

.chart-area-line {
  flex: 1 1;
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.grid-lines-line {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  pointer-events: none;
  z-index: 0;
  padding: 5% 0;
}

.grid-line-line {
  width: 100%;
  height: 1px;
  background: linear-gradient(to right, transparent 0%, var(--primary-color) 2%, var(--primary-color) 98%, transparent 100%);
  opacity: 0.25;
}

.line-chart-svg {
  position: relative;
  z-index: 1;
  flex: 1 1;
  min-height: 0;
  overflow: visible;
}

.line-chart-polyline {
  filter: drop-shadow(0 3px 6px rgba(7, 255, 169, 0.4));
}

.line-point-group {
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.line-point-group:hover .line-point {
  r: 6.5;
  stroke-width: 3.5;
  filter: drop-shadow(0 0 12px rgba(7, 255, 169, 0.8));
  transform: scale(1.1);
}

.line-point-group:hover .line-point-halo {
  r: 14;
  opacity: 0.25;
}

.line-point-group:hover .line-point-value {
  opacity: 1;
  transform: translateY(-2px);
}

.line-point-inner {
  pointer-events: none;
}

.line-labels-enhanced {
  display: flex;
  justify-content: space-between;
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 2px solid var(--primary-color);
  opacity: 0.3;
  position: relative;
}

.line-labels-enhanced::before {
  content: '';
  position: absolute;
  top: -1px;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(to right, transparent, var(--secondary-color) 50%, transparent);
  opacity: 0.5;
}

.line-label-enhanced {
  font-size: 0.85rem;
  color: var(--text-primary);
  text-align: center;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  flex: 1 1;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  position: relative;
}

.line-label-enhanced:hover {
  color: var(--secondary-color);
  font-weight: 700;
  transform: translateY(-3px);
  background: var(--bg-tertiary);
}

/* Radar Chart */
.radar-chart {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.radar-labels {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.5rem;
  margin-top: 1rem;
}

.radar-label {
  font-size: 0.75rem;
  color: var(--text-secondary);
  padding: 0.25rem 0.5rem;
  background: var(--bg-tertiary);
  border-radius: 12px;
}

/* Objectives Section */
.objectives-section {
  width: 100%;
  margin: 0 auto;
}

.objectives-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 1.5rem;
  width: 100%;
}

.objective-card {
  background: #ffffff;
  border-radius: var(--border-radius-lg);
  padding: 2rem 2.5rem;
  box-shadow: var(--shadow-md);
  transition: var(--transition);
  border: 1px solid rgba(172, 203, 195, 0.2);
}

.objective-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(7, 255, 169, 0.2);
  border-color: rgba(7, 255, 169, 0.4);
}

.objective-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  gap: 1rem;
}

.objective-header h4 {
  font-size: 1.125rem;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0;
  flex: 1 1;
}

.objective-header .donut-chart {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.objective-details {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.detail-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.detail-item .label {
  font-size: 0.875rem;
  color: var(--text-secondary);
}

.status {
  padding: 0.25rem 0.75rem;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
}

.status.excellent {
  background: rgba(7, 255, 169, 0.15);
  color: #07ffa9;
}

.status.good {
  background: rgba(31, 124, 80, 0.15);
  color: #1f7c50;
}

.status.needs-improvement {
  background: rgba(239, 68, 68, 0.15);
  color: #ef4444;
}

.priority {
  color: var(--secondary-color);
  font-weight: 600;
  font-size: 0.875rem;
}

.date {
  color: var(--text-muted);
  font-size: 0.875rem;
}

/* Controls Section */
.controls-section {
  width: 100%;
  margin: 0 auto;
}

.controls-overview {
  margin-bottom: 2rem;
  width: 100%;
}

.control-stats {
  display: flex;
  flex-direction: row;
  gap: 1.5rem;
  margin-bottom: 2rem;
  flex-wrap: nowrap;
  width: 100%;
}

.stat-card {
  background: #ffffff;
  border-radius: var(--border-radius);
  padding: 1.5rem 2rem;
  text-align: center;
  box-shadow: var(--shadow-sm);
  transition: var(--transition);
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0.75rem;
  border: 1px solid rgba(172, 203, 195, 0.2);
}

.stat-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(7, 255, 169, 0.2);
  border-color: rgba(7, 255, 169, 0.4);
}

.stat-icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: var(--bg-secondary);
  margin-bottom: 0.5rem;
  transition: var(--transition);
}

.stat-card:hover .stat-icon-wrapper {
  transform: scale(1.1);
  background: var(--bg-tertiary);
}

.stat-card h4 {
  font-size: 0.875rem;
  color: var(--text-secondary);
  margin-bottom: 0.25rem;
  font-weight: 500;
  margin-top: 0;
}

.stat-number {
  font-size: 2rem;
  font-weight: 700;
  color: var(--text-primary);
  margin-top: 0;
}

.control-mapping {
  background: #ffffff;
  border-radius: var(--border-radius-lg);
  padding: 2rem;
  box-shadow: var(--shadow-md);
  border: 1px solid rgba(172, 203, 195, 0.2);
}

.control-mapping h3 {
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 1.5rem;
  text-align: center;
}

/* Standards Section */
.standards-section {
  width: 100%;
  margin: 0 auto;
}

.standards-overview {
  background: var(--bg-primary);
  border-radius: var(--border-radius-lg);
  padding: 2rem;
  box-shadow: var(--shadow-md);
  margin-bottom: 2rem;
  text-align: center;
}

.standards-details {
  background: #ffffff;
  border-radius: var(--border-radius-lg);
  padding: 2rem;
  box-shadow: var(--shadow-md);
  width: 100%;
  border: 1px solid rgba(172, 203, 195, 0.2);
}

.standards-details h3 {
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 1.5rem;
  text-align: center;
}

.standards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1.5rem;
  width: 100%;
}

.standard-card {
  background: var(--bg-secondary);
  border-radius: var(--border-radius);
  padding: 1.5rem;
  transition: var(--transition);
  border: 1px solid rgba(172, 203, 195, 0.2);
}

.standard-card:hover {
  transform: translateY(-2px);
  border-color: rgba(7, 255, 169, 0.4);
  box-shadow: 0 4px 15px rgba(7, 255, 169, 0.15);
}

.standard-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.standard-header h4 {
  font-size: 1rem;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0;
}

.score {
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--secondary-color);
}

.progress-bar {
  width: 100%;
  height: 8px;
  background: var(--bg-tertiary);
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 1rem;
}

.progress-fill {
  height: 100%;
  background: var(--gradient-secondary);
  border-radius: 4px;
  transition: width 1s ease-in-out;
}

.standard-metrics {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
}

.metric {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.metric-label {
  font-size: 0.75rem;
  color: var(--text-secondary);
  margin-bottom: 0.25rem;
}

.metric-value {
  font-size: 1rem;
  font-weight: 600;
  color: var(--text-primary);
}

/* Responsive Design */
@media (max-width: 768px) {
  .assessment-score-page {
    padding: 0.5rem;
  }
  
  .assessment-header h1 {
    font-size: 2rem;
  }
  
  .tab-navigation {
    flex-wrap: wrap;
    gap: 0.25rem;
  }
  
  .tab-button {
    padding: 0.5rem 1rem;
    font-size: 0.875rem;
  }
  
  .assessment-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
  
  .main-score {
    grid-column: span 1;
  }
  
  .objectives-grid,
  .control-stats {
    flex-direction: column;
  }
  
  .stat-card {
    min-width: 100%;
  }
  
  .standards-grid {
    grid-template-columns: 1fr;
  }
  
  .bars {
    gap: 0.5rem;
  }
  
  .bar-label {
    font-size: 0.625rem;
    max-width: 60px;
  }
  
  .bar-chart-enhanced {
    gap: 0.5rem;
    padding: 0.5rem;
  }
  
  .y-axis-labels {
    min-width: 40px;
    padding-right: 0.5rem;
  }
  
  .y-axis-label {
    font-size: 0.65rem;
  }
  
  .bars-enhanced {
    gap: 0.75rem;
  }
  
  .bar-enhanced {
    max-width: 60px;
    min-width: 40px;
  }
  
  .bar-label-enhanced {
    font-size: 0.7rem;
  }
  
  .bar-value-enhanced {
    font-size: 0.75rem;
    padding: 0.2rem 0.4rem;
    top: -24px;
  }
}

@media (max-width: 480px) {
  .assessment-header h1 {
    font-size: 1.75rem;
  }
  
  .assessment-header p {
    font-size: 1rem;
  }
  
  .score-card {
    padding: 1.5rem;
  }
  
  .objective-card,
  .standard-card {
    padding: 1rem;
  }
  
  .bar-label {
    font-size: 0.5rem;
    max-width: 50px;
  }
  
  .bar-chart-enhanced {
    flex-direction: column;
    gap: 0.5rem;
    padding: 0.5rem;
  }
  
  .y-axis-labels {
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    min-width: auto;
    padding-right: 0;
    padding-bottom: 0.5rem;
    height: auto;
  }
  
  .y-axis-label {
    font-size: 0.6rem;
  }
  
  .chart-area {
    width: 100%;
  }
  
  .bars-enhanced {
    gap: 0.5rem;
  }
  
  .bar-enhanced {
    max-width: 50px;
    min-width: 35px;
  }
  
  .bar-label-enhanced {
    font-size: 0.65rem;
  }
  
  .bar-value-enhanced {
    font-size: 0.7rem;
    padding: 0.15rem 0.3rem;
    top: -22px;
  }
  
  .line-chart-enhanced {
    gap: 0.5rem;
    padding: 0.5rem;
  }
  
  .y-axis-labels-line {
    min-width: 40px;
    padding-right: 0.5rem;
  }
  
  .y-axis-label-line {
    font-size: 0.65rem;
  }
  
  .line-label-enhanced {
    font-size: 0.7rem;
  }
}

/* Professional Government-Appropriate Animations */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInFromLeft {
  from {
    opacity: 0;
    transform: translateX(-30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes slideInFromRight {
  from {
    opacity: 0;
    transform: translateX(30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes scaleIn {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

/* Smooth Donut Chart Progress Animation */
@keyframes drawProgress {
  from {
    stroke-dasharray: 0 1000;
  }
  to {
    stroke-dasharray: var(--progress-dasharray);
  }
}

/* Smooth Bar Chart Growth Animation */
@keyframes growBar {
  from {
    height: 0;
    opacity: 0;
  }
  to {
    height: var(--bar-height);
    opacity: 1;
  }
}

/* Smooth Line Chart Drawing Animation */
@keyframes drawLine {
  from {
    stroke-dashoffset: 1000;
  }
  to {
    stroke-dashoffset: 0;
  }
}

/* Smooth Radar Chart Drawing Animation */
@keyframes drawRadar {
  from {
    stroke-dasharray: 0 1000;
    opacity: 0;
  }
  to {
    stroke-dasharray: 1000 0;
    opacity: 1;
  }
}

/* Smooth Pulse Animation for Data Points */
@keyframes pulseIn {
  0% {
    opacity: 0;
    transform: scale(0.3);
  }
  50% {
    opacity: 0.8;
    transform: scale(1.1);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

/* Professional Stagger Animation */
@keyframes staggerIn {
  from {
    opacity: 0;
    transform: translateY(20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* Card Animations */
.score-card,
.objective-card,
.standard-card,
.stat-card {
  animation: fadeInUp 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.tab-button {
  animation: slideInFromLeft 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

/* Professional Chart Animations */
.donut-chart svg circle:last-child {
  animation: drawProgress 2.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;
}

.bar {
  animation: growBar 1.2s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;
  animation-delay: var(--bar-delay, 0s);
}

.line-chart polyline {
  animation: drawLine 2s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;
}

.radar-chart polygon {
  animation: drawRadar 1.8s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;
}

.radar-chart circle {
  animation: pulseIn 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;
  animation-delay: var(--point-delay, 0s);
}

/* Professional Hover Effects */
.bar:hover {
  transform: scale(1.02) translateY(-2px);
  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.bar:hover .bar-value {
  transform: scale(1.05) translateY(-2px);
  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.score-card:hover,
.objective-card:hover,
.standard-card:hover {
  transform: translateY(-4px) scale(1.01);
  transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

/* Staggered Animation for Multiple Elements */
.bar-group:nth-child(1) { --bar-delay: 0.1s; }
.bar-group:nth-child(2) { --bar-delay: 0.2s; }
.bar-group:nth-child(3) { --bar-delay: 0.3s; }
.bar-group:nth-child(4) { --bar-delay: 0.4s; }
.bar-group:nth-child(5) { --bar-delay: 0.5s; }

.radar-chart circle:nth-child(1) { --point-delay: 0.2s; }
.radar-chart circle:nth-child(2) { --point-delay: 0.4s; }
.radar-chart circle:nth-child(3) { --point-delay: 0.6s; }
.radar-chart circle:nth-child(4) { --point-delay: 0.8s; }
.radar-chart circle:nth-child(5) { --point-delay: 1s; }
.radar-chart circle:nth-child(6) { --point-delay: 1.2s; }

/* Custom scrollbar */
.assessment-score-page::-webkit-scrollbar {
  width: 8px;
}

.assessment-score-page::-webkit-scrollbar-track {
  background: var(--bg-tertiary);
  border-radius: 4px;
}

.assessment-score-page::-webkit-scrollbar-thumb {
  background: #1f7c50;
  border-radius: 4px;
}

.assessment-score-page::-webkit-scrollbar-thumb:hover {
  background: #07ffa9;
} `, "",{"version":3,"sources":["webpack://./src/pages/frameWork/AssessmentScore.css"],"names":[],"mappings":"AAAA,yDAAyD;AACzD;EACE,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,sCAAsC;EACtC,mCAAmC;EACnC,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,qBAAqB;EACrB,uBAAuB;EACvB,oGAAoG;EACpG,uEAAuE;EACvE,4CAA4C;EAC5C,kFAAkF;EAClF,oFAAoF;EACpF,qBAAqB;EACrB,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB;;qBAEmB;EACnB,aAAa;EACb,mEAAmE;EACnE,0BAA0B;AAC5B;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,qBAAqB;EACrB,qCAAqC;EACrC,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,gBAAgB;EAChB,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,sCAAsC;EACtC,4BAA4B;EAC5B,2CAA2C;AAC7C;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,4BAA4B;EAC5B,gBAAgB;EAChB,mCAAmC;EACnC,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,2CAA2C;AAC7C;;AAEA,uBAAuB;AACvB;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,6FAA6F;EAC7F,6BAA6B;;EAE7B,qBAAqB;EACrB,kBAAkB;EAClB,6BAA6B;AAC/B;;;;AAIA,oBAAoB;AACpB;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,sCAAsC;EACtC,aAAa;EACb,4BAA4B;EAC5B,6BAA6B;EAC7B,0CAA0C;AAC5C;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;EAC7C,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,qCAAqC;EACrC,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,4BAA4B;EAC5B,SAAS;EACT,kBAAkB;AACpB;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,6BAA6B;EAC7B,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAO;EACP,YAAY;AACd;;AAEA;EACE,WAAW;EACX,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,4BAA4B;EAC5B,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kHAAkH;EAClH,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,6BAA6B;EAC7B,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAO;EACP,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;EAClB,yDAAyD;EACzD,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,uCAAuC;EACvC,sCAAsC;EACtC,qDAAqD;AACvD;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;EAC1B,6BAA6B;EAC7B,uBAAuB;EACvB,kBAAkB;EAClB,4BAA4B;EAC5B,mBAAmB;EACnB,UAAU;EACV,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,oBAAoB;EACpB,YAAY;EACZ,6EAA6E;EAC7E,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,oBAAoB;EACpB,UAAU;EACV,aAAa;AACf;;AAEA;EACE,WAAW;EACX,WAAW;EACX,0HAA0H;EAC1H,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAO;EACP,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,MAAM;EACN,iBAAiB;EACjB,oDAAoD;EACpD,qBAAqB;AACvB;;AAEA;EACE,KAAK;EACL,aAAa;AACf;;AAEA;EACE,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,iBAAiB;EACjB,0CAA0C;EAC1C,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,2FAA2F;EAC3F,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iDAAiD;EACjD,SAAO;EACP,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,uBAAuB;EACvB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,oBAAoB;EACpB,4BAA4B;EAC5B,6BAA6B;EAC7B,0CAA0C;AAC5C;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;EAC7C,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;EACT,SAAO;AACT;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,mCAAmC;EACnC,oBAAoB;EACpB,kBAAkB;EAClB,4BAA4B;EAC5B,6BAA6B;EAC7B,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;EAC7C,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,aAAa;EACb,4BAA4B;EAC5B,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,sCAAsC;EACtC,aAAa;EACb,4BAA4B;EAC5B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,aAAa;EACb,4BAA4B;EAC5B,WAAW;EACX,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,mCAAmC;EACnC,eAAe;EACf,6BAA6B;EAC7B,0CAA0C;AAC5C;;AAEA;EACE,2BAA2B;EAC3B,oCAAoC;EACpC,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,WAAW;EACX,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,uBAAuB;IACvB,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,mDAAmD;AACnD;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA,0CAA0C;AAC1C;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2CAA2C;EAC7C;AACF;;AAEA,sCAAsC;AACtC;EACE;IACE,SAAS;IACT,UAAU;EACZ;EACA;IACE,yBAAyB;IACzB,UAAU;EACZ;AACF;;AAEA,wCAAwC;AACxC;EACE;IACE,uBAAuB;EACzB;EACA;IACE,oBAAoB;EACtB;AACF;;AAEA,yCAAyC;AACzC;EACE;IACE,wBAAwB;IACxB,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA,2CAA2C;AAC3C;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,YAAY;IACZ,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA,mCAAmC;AACnC;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA,oBAAoB;AACpB;;;;EAIE,6DAA6D;AAC/D;;AAEA;EACE,oEAAoE;AACtE;;AAEA,kCAAkC;AAClC;EACE,0EAA0E;AAC5E;;AAEA;EACE,qEAAqE;EACrE,qCAAqC;AACvC;;AAEA;EACE,oEAAoE;AACtE;;AAEA;EACE,uEAAuE;AACzE;;AAEA;EACE,qEAAqE;EACrE,uCAAuC;AACzC;;AAEA,+BAA+B;AAC/B;EACE,uCAAuC;EACvC,yDAAyD;AAC3D;;AAEA;EACE,uCAAuC;EACvC,yDAAyD;AAC3D;;AAEA;;;EAGE,uCAAuC;EACvC,yDAAyD;AAC3D;;AAEA,8CAA8C;AAC9C,0BAA0B,iBAAiB,EAAE;AAC7C,0BAA0B,iBAAiB,EAAE;AAC7C,0BAA0B,iBAAiB,EAAE;AAC7C,0BAA0B,iBAAiB,EAAE;AAC7C,0BAA0B,iBAAiB,EAAE;;AAE7C,mCAAmC,mBAAmB,EAAE;AACxD,mCAAmC,mBAAmB,EAAE;AACxD,mCAAmC,mBAAmB,EAAE;AACxD,mCAAmC,mBAAmB,EAAE;AACxD,mCAAmC,iBAAiB,EAAE;AACtD,mCAAmC,mBAAmB,EAAE;;AAExD,qBAAqB;AACrB;EACE,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["/* Assessment Score Dashboard Styles - Qatar Gray Theme */\r\n:root {\r\n  --primary-color: #e2e8f0;\r\n  --primary-light: #f1f5f9;\r\n  --primary-dark: #cbd5e1;\r\n  --secondary-color: hsl(159, 100%, 51%);\r\n  --accent-color: hsl(159, 100%, 51%);\r\n  --text-primary: #1e293b;\r\n  --text-secondary: #475569;\r\n  --text-muted: #64748b;\r\n  --bg-primary: #f8fafc;\r\n  --bg-secondary: #f1f5f9;\r\n  --bg-tertiary: #e2e8f0;\r\n  --success-color: #07ffa9;\r\n  --warning-color: #1f7c50;\r\n  --danger-color: #ef4444;\r\n  --info-color: #07ffa9;\r\n  --purple-color: #1f7c50;\r\n  --gradient-primary: linear-gradient(135deg, rgba(7, 255, 169, 0.1) 0%, rgba(31, 124, 80, 0.15) 100%);\r\n  --gradient-secondary: linear-gradient(135deg, #07ffa9 0%, #1f7c50 100%);\r\n  --shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\r\n  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\r\n  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\r\n  --border-radius: 12px;\r\n  --border-radius-lg: 16px;\r\n  --transition: all 0.3s ease-in-out;\r\n}\r\n\r\n.assessment-score-page {\r\n  min-height: 100vh;\r\n  background: radial-gradient(circle at 0% 0%, rgba(7, 255, 169, 0.05), transparent 55%),\r\n              radial-gradient(circle at 100% 100%, rgba(31, 124, 80, 0.08), transparent 60%),\r\n              #f1f5f9;\r\n  padding: 1rem;\r\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;\r\n  color: var(--text-primary);\r\n}\r\n\r\n/* Header Styles */\r\n.assessment-header {\r\n  text-align: center;\r\n  margin-bottom: 2rem;\r\n  padding: 2rem 0;\r\n}\r\n\r\n.assessment-header h1 {\r\n  font-size: 2.5rem;\r\n  font-weight: 700;\r\n  color: var(--text-primary);\r\n  margin-bottom: 0.5rem;\r\n  background: var(--gradient-secondary);\r\n  -webkit-background-clip: text;\r\n  -webkit-text-fill-color: transparent;\r\n  background-clip: text;\r\n}\r\n\r\n.assessment-header p {\r\n  font-size: 1.1rem;\r\n  color: var(--text-secondary);\r\n  max-width: 600px;\r\n  margin: 0 auto;\r\n}\r\n\r\n/* Tab Navigation */\r\n.tab-navigation {\r\n  display: flex;\r\n  justify-content: center;\r\n  gap: 0.5rem;\r\n  margin-bottom: 2rem;\r\n  background: var(--bg-primary);\r\n  padding: 0.5rem;\r\n  border-radius: var(--border-radius-lg);\r\n  box-shadow: var(--shadow-md);\r\n  border: 1px solid rgba(172, 203, 195, 0.15);\r\n}\r\n\r\n.tab-button {\r\n  padding: 0.75rem 1.5rem;\r\n  border: none;\r\n  background: transparent;\r\n  color: var(--text-secondary);\r\n  font-weight: 500;\r\n  border-radius: var(--border-radius);\r\n  cursor: pointer;\r\n  transition: var(--transition);\r\n  font-size: 0.95rem;\r\n}\r\n\r\n.tab-button:hover {\r\n  background: rgba(7, 255, 169, 0.1);\r\n  color: var(--text-primary);\r\n}\r\n\r\n.tab-button.active {\r\n  background: var(--gradient-secondary);\r\n  color: #ffffff;\r\n  box-shadow: 0 0 15px rgba(7, 255, 169, 0.3);\r\n}\r\n\r\n/* Assessment Content */\r\n.assessment-content {\r\n  max-width: 1400px;\r\n  margin: 0 auto;\r\n}\r\n\r\n/* Assessment Sections */\r\n.assessment-section {\r\n  margin-bottom: 4rem;\r\n}\r\n\r\n.assessment-section:last-child {\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.section-title {\r\n  font-size: 2rem;\r\n  font-weight: 700;\r\n  margin-bottom: 2rem;\r\n  padding-bottom: 1rem;\r\n  background: linear-gradient(135deg, var(--secondary-color) 0%, var(--secondary-color)dd 100%);\r\n  -webkit-background-clip: text;\r\n \r\n  background-clip: text;\r\n  position: relative;\r\n  color: var(--secondary-color);\r\n}\r\n\r\n\r\n\r\n/* Assessment Grid */\r\n.assessment-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));\r\n  gap: 1.5rem;\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n/* Score Cards */\r\n.score-card {\r\n  background: #ffffff;\r\n  border-radius: var(--border-radius-lg);\r\n  padding: 2rem;\r\n  box-shadow: var(--shadow-md);\r\n  transition: var(--transition);\r\n  border: 1px solid rgba(172, 203, 195, 0.2);\r\n}\r\n\r\n.score-card:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 8px 25px rgba(7, 255, 169, 0.2);\r\n  border-color: rgba(7, 255, 169, 0.4);\r\n}\r\n\r\n.score-card h3 {\r\n  font-size: 1.25rem;\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n  margin-bottom: 1.5rem;\r\n  text-align: center;\r\n}\r\n\r\n.main-score {\r\n  grid-column: span 2;\r\n  text-align: center;\r\n}\r\n\r\n.main-score h3 {\r\n  font-size: 1.5rem;\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n/* Donut Chart */\r\n.donut-chart {\r\n  position: relative;\r\n  display: inline-block;\r\n  margin: 0 auto;\r\n  width: fit-content;\r\n  height: fit-content;\r\n}\r\n\r\n.objective-header .donut-chart {\r\n  margin: 0;\r\n}\r\n\r\n.donut-label {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  text-align: center;\r\n}\r\n\r\n.donut-label .percentage {\r\n  display: block;\r\n  font-size: 2rem;\r\n  font-weight: 700;\r\n  color: var(--text-primary);\r\n  line-height: 1;\r\n}\r\n\r\n.donut-label .label {\r\n  display: block;\r\n  font-size: 0.875rem;\r\n  color: var(--text-secondary);\r\n  margin-top: 0.25rem;\r\n}\r\n\r\n/* Score Details */\r\n.score-details {\r\n  margin-top: 1.5rem;\r\n}\r\n\r\n.score-level {\r\n  text-align: center;\r\n}\r\n\r\n.level-badge {\r\n  display: inline-block;\r\n  padding: 0.5rem 1rem;\r\n  background: var(--gradient-secondary);\r\n  color: #ffffff;\r\n  border-radius: 20px;\r\n  font-weight: 600;\r\n  font-size: 0.875rem;\r\n  margin-bottom: 0.5rem;\r\n  box-shadow: 0 0 15px rgba(7, 255, 169, 0.3);\r\n}\r\n\r\n.score-level p {\r\n  color: var(--text-secondary);\r\n  margin: 0;\r\n  font-size: 0.95rem;\r\n}\r\n\r\n/* Bar Chart */\r\n.bar-chart {\r\n  position: relative;\r\n  padding: 1rem 0;\r\n}\r\n\r\n.bars {\r\n  display: flex;\r\n  align-items: end;\r\n  justify-content: space-around;\r\n  height: 100%;\r\n  gap: 1rem;\r\n}\r\n\r\n.bar-group {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  flex: 1;\r\n  height: 100%;\r\n}\r\n\r\n.bar {\r\n  width: 100%;\r\n  max-width: 60px;\r\n  border-radius: 6px 6px 0 0;\r\n  position: relative;\r\n  transition: var(--transition);\r\n  display: flex;\r\n  align-items: flex-end;\r\n  justify-content: center;\r\n  min-height: 20px;\r\n}\r\n\r\n.bar:hover {\r\n  transform: scale(1.05);\r\n}\r\n\r\n.bar-value {\r\n  position: absolute;\r\n  top: -25px;\r\n  font-size: 0.75rem;\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.bar-label {\r\n  margin-top: 0.5rem;\r\n  font-size: 0.75rem;\r\n  color: var(--text-secondary);\r\n  text-align: center;\r\n  transform: rotate(-45deg);\r\n  white-space: nowrap;\r\n  max-width: 80px;\r\n}\r\n\r\n/* Enhanced Bar Chart */\r\n.bar-chart-enhanced {\r\n  position: relative;\r\n  display: flex;\r\n  gap: 1rem;\r\n  padding: 1rem;\r\n  height: 100%;\r\n}\r\n\r\n.y-axis-labels {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: space-between;\r\n  align-items: flex-end;\r\n  padding-right: 0.75rem;\r\n  min-width: 50px;\r\n  height: 100%;\r\n}\r\n\r\n.y-axis-label {\r\n  font-size: 0.75rem;\r\n  color: var(--text-secondary);\r\n  font-weight: 500;\r\n}\r\n\r\n.chart-area {\r\n  flex: 1;\r\n  position: relative;\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.grid-lines {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: space-between;\r\n  pointer-events: none;\r\n  z-index: 0;\r\n}\r\n\r\n.grid-line {\r\n  width: 100%;\r\n  height: 1px;\r\n  background: linear-gradient(to right, transparent, var(--primary-color) 5%, var(--primary-color) 95%, transparent);\r\n  opacity: 0.3;\r\n}\r\n\r\n.bars-enhanced {\r\n  position: relative;\r\n  display: flex;\r\n  align-items: flex-end;\r\n  justify-content: space-around;\r\n  height: 100%;\r\n  gap: 1.5rem;\r\n  padding: 0.5rem 0;\r\n  z-index: 1;\r\n}\r\n\r\n.bar-group-enhanced {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  flex: 1;\r\n  height: 100%;\r\n  max-width: 120px;\r\n}\r\n\r\n.bar-wrapper {\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  align-items: flex-end;\r\n  justify-content: center;\r\n  position: relative;\r\n}\r\n\r\n.bar-enhanced {\r\n  width: 100%;\r\n  max-width: 80px;\r\n  min-width: 50px;\r\n  border-radius: 8px 8px 0 0;\r\n  position: relative;\r\n  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: center;\r\n  min-height: 30px;\r\n  cursor: pointer;\r\n  border: 2px solid transparent;\r\n}\r\n\r\n.bar-enhanced:hover {\r\n  transform: translateY(-4px) scale(1.05);\r\n  border-color: rgba(255, 255, 255, 0.3);\r\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15) !important;\r\n}\r\n\r\n.bar-value-enhanced {\r\n  position: absolute;\r\n  top: -28px;\r\n  font-size: 0.875rem;\r\n  font-weight: 700;\r\n  color: var(--text-primary);\r\n  background: var(--bg-primary);\r\n  padding: 0.25rem 0.5rem;\r\n  border-radius: 4px;\r\n  box-shadow: var(--shadow-sm);\r\n  white-space: nowrap;\r\n  opacity: 0;\r\n  transition: opacity 0.3s ease;\r\n  z-index: 10;\r\n}\r\n\r\n.bar-enhanced:hover .bar-value-enhanced {\r\n  opacity: 1;\r\n}\r\n\r\n.bar-label-enhanced {\r\n  margin-top: 0.75rem;\r\n  font-size: 0.8rem;\r\n  color: var(--text-primary);\r\n  text-align: center;\r\n  font-weight: 500;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  max-width: 100%;\r\n  line-height: 1.2;\r\n}\r\n\r\n/* Line Chart */\r\n.line-chart {\r\n  position: relative;\r\n  padding: 1rem;\r\n}\r\n\r\n.line-labels {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  margin-top: 0.5rem;\r\n}\r\n\r\n.line-label {\r\n  font-size: 0.75rem;\r\n  color: var(--text-secondary);\r\n  text-align: center;\r\n}\r\n\r\n/* Enhanced Line Chart */\r\n.line-chart-enhanced {\r\n  position: relative;\r\n  display: flex;\r\n  gap: 1.25rem;\r\n  padding: 1.5rem 1rem;\r\n  height: 100%;\r\n  background: linear-gradient(to bottom, transparent, var(--bg-secondary) 100%);\r\n  border-radius: var(--border-radius);\r\n}\r\n\r\n.y-axis-labels-line {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: space-between;\r\n  align-items: flex-end;\r\n  padding-right: 1rem;\r\n  min-width: 55px;\r\n  height: 100%;\r\n}\r\n\r\n.y-axis-label-line {\r\n  font-size: 0.8rem;\r\n  color: var(--text-secondary);\r\n  font-weight: 600;\r\n  letter-spacing: 0.5px;\r\n}\r\n\r\n.chart-area-line {\r\n  flex: 1;\r\n  position: relative;\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-height: 0;\r\n}\r\n\r\n.grid-lines-line {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: space-between;\r\n  pointer-events: none;\r\n  z-index: 0;\r\n  padding: 5% 0;\r\n}\r\n\r\n.grid-line-line {\r\n  width: 100%;\r\n  height: 1px;\r\n  background: linear-gradient(to right, transparent 0%, var(--primary-color) 2%, var(--primary-color) 98%, transparent 100%);\r\n  opacity: 0.25;\r\n}\r\n\r\n.line-chart-svg {\r\n  position: relative;\r\n  z-index: 1;\r\n  flex: 1;\r\n  min-height: 0;\r\n  overflow: visible;\r\n}\r\n\r\n.line-chart-polyline {\r\n  filter: drop-shadow(0 3px 6px rgba(7, 255, 169, 0.4));\r\n}\r\n\r\n.line-point-group {\r\n  cursor: pointer;\r\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n}\r\n\r\n.line-point-group:hover .line-point {\r\n  r: 6.5;\r\n  stroke-width: 3.5;\r\n  filter: drop-shadow(0 0 12px rgba(7, 255, 169, 0.8));\r\n  transform: scale(1.1);\r\n}\r\n\r\n.line-point-group:hover .line-point-halo {\r\n  r: 14;\r\n  opacity: 0.25;\r\n}\r\n\r\n.line-point-group:hover .line-point-value {\r\n  opacity: 1;\r\n  transform: translateY(-2px);\r\n}\r\n\r\n.line-point-inner {\r\n  pointer-events: none;\r\n}\r\n\r\n.line-labels-enhanced {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  margin-top: 1rem;\r\n  padding-top: 1rem;\r\n  border-top: 2px solid var(--primary-color);\r\n  opacity: 0.3;\r\n  position: relative;\r\n}\r\n\r\n.line-labels-enhanced::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: -1px;\r\n  left: 0;\r\n  right: 0;\r\n  height: 1px;\r\n  background: linear-gradient(to right, transparent, var(--secondary-color) 50%, transparent);\r\n  opacity: 0.5;\r\n}\r\n\r\n.line-label-enhanced {\r\n  font-size: 0.85rem;\r\n  color: var(--text-primary);\r\n  text-align: center;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n  flex: 1;\r\n  padding: 0.25rem 0.5rem;\r\n  border-radius: 4px;\r\n  position: relative;\r\n}\r\n\r\n.line-label-enhanced:hover {\r\n  color: var(--secondary-color);\r\n  font-weight: 700;\r\n  transform: translateY(-3px);\r\n  background: var(--bg-tertiary);\r\n}\r\n\r\n/* Radar Chart */\r\n.radar-chart {\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n}\r\n\r\n.radar-labels {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  justify-content: center;\r\n  gap: 0.5rem;\r\n  margin-top: 1rem;\r\n}\r\n\r\n.radar-label {\r\n  font-size: 0.75rem;\r\n  color: var(--text-secondary);\r\n  padding: 0.25rem 0.5rem;\r\n  background: var(--bg-tertiary);\r\n  border-radius: 12px;\r\n}\r\n\r\n/* Objectives Section */\r\n.objectives-section {\r\n  width: 100%;\r\n  margin: 0 auto;\r\n}\r\n\r\n.objectives-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));\r\n  gap: 1.5rem;\r\n  width: 100%;\r\n}\r\n\r\n.objective-card {\r\n  background: #ffffff;\r\n  border-radius: var(--border-radius-lg);\r\n  padding: 2rem 2.5rem;\r\n  box-shadow: var(--shadow-md);\r\n  transition: var(--transition);\r\n  border: 1px solid rgba(172, 203, 195, 0.2);\r\n}\r\n\r\n.objective-card:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 8px 25px rgba(7, 255, 169, 0.2);\r\n  border-color: rgba(7, 255, 169, 0.4);\r\n}\r\n\r\n.objective-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 1rem;\r\n  gap: 1rem;\r\n}\r\n\r\n.objective-header h4 {\r\n  font-size: 1.125rem;\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n  margin: 0;\r\n  flex: 1;\r\n}\r\n\r\n.objective-header .donut-chart {\r\n  flex-shrink: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.objective-details {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.75rem;\r\n}\r\n\r\n.detail-item {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.detail-item .label {\r\n  font-size: 0.875rem;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.status {\r\n  padding: 0.25rem 0.75rem;\r\n  border-radius: 12px;\r\n  font-size: 0.75rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.status.excellent {\r\n  background: rgba(7, 255, 169, 0.15);\r\n  color: #07ffa9;\r\n}\r\n\r\n.status.good {\r\n  background: rgba(31, 124, 80, 0.15);\r\n  color: #1f7c50;\r\n}\r\n\r\n.status.needs-improvement {\r\n  background: rgba(239, 68, 68, 0.15);\r\n  color: #ef4444;\r\n}\r\n\r\n.priority {\r\n  color: var(--secondary-color);\r\n  font-weight: 600;\r\n  font-size: 0.875rem;\r\n}\r\n\r\n.date {\r\n  color: var(--text-muted);\r\n  font-size: 0.875rem;\r\n}\r\n\r\n/* Controls Section */\r\n.controls-section {\r\n  width: 100%;\r\n  margin: 0 auto;\r\n}\r\n\r\n.controls-overview {\r\n  margin-bottom: 2rem;\r\n  width: 100%;\r\n}\r\n\r\n.control-stats {\r\n  display: flex;\r\n  flex-direction: row;\r\n  gap: 1.5rem;\r\n  margin-bottom: 2rem;\r\n  flex-wrap: nowrap;\r\n  width: 100%;\r\n}\r\n\r\n.stat-card {\r\n  background: #ffffff;\r\n  border-radius: var(--border-radius);\r\n  padding: 1.5rem 2rem;\r\n  text-align: center;\r\n  box-shadow: var(--shadow-sm);\r\n  transition: var(--transition);\r\n  flex: 1;\r\n  min-width: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 0.75rem;\r\n  border: 1px solid rgba(172, 203, 195, 0.2);\r\n}\r\n\r\n.stat-card:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 8px 25px rgba(7, 255, 169, 0.2);\r\n  border-color: rgba(7, 255, 169, 0.4);\r\n}\r\n\r\n.stat-icon-wrapper {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 64px;\r\n  height: 64px;\r\n  border-radius: 50%;\r\n  background: var(--bg-secondary);\r\n  margin-bottom: 0.5rem;\r\n  transition: var(--transition);\r\n}\r\n\r\n.stat-card:hover .stat-icon-wrapper {\r\n  transform: scale(1.1);\r\n  background: var(--bg-tertiary);\r\n}\r\n\r\n.stat-card h4 {\r\n  font-size: 0.875rem;\r\n  color: var(--text-secondary);\r\n  margin-bottom: 0.25rem;\r\n  font-weight: 500;\r\n  margin-top: 0;\r\n}\r\n\r\n.stat-number {\r\n  font-size: 2rem;\r\n  font-weight: 700;\r\n  color: var(--text-primary);\r\n  margin-top: 0;\r\n}\r\n\r\n.control-mapping {\r\n  background: #ffffff;\r\n  border-radius: var(--border-radius-lg);\r\n  padding: 2rem;\r\n  box-shadow: var(--shadow-md);\r\n  border: 1px solid rgba(172, 203, 195, 0.2);\r\n}\r\n\r\n.control-mapping h3 {\r\n  font-size: 1.25rem;\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n  margin-bottom: 1.5rem;\r\n  text-align: center;\r\n}\r\n\r\n/* Standards Section */\r\n.standards-section {\r\n  width: 100%;\r\n  margin: 0 auto;\r\n}\r\n\r\n.standards-overview {\r\n  background: var(--bg-primary);\r\n  border-radius: var(--border-radius-lg);\r\n  padding: 2rem;\r\n  box-shadow: var(--shadow-md);\r\n  margin-bottom: 2rem;\r\n  text-align: center;\r\n}\r\n\r\n.standards-details {\r\n  background: #ffffff;\r\n  border-radius: var(--border-radius-lg);\r\n  padding: 2rem;\r\n  box-shadow: var(--shadow-md);\r\n  width: 100%;\r\n  border: 1px solid rgba(172, 203, 195, 0.2);\r\n}\r\n\r\n.standards-details h3 {\r\n  font-size: 1.25rem;\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n  margin-bottom: 1.5rem;\r\n  text-align: center;\r\n}\r\n\r\n.standards-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\r\n  gap: 1.5rem;\r\n  width: 100%;\r\n}\r\n\r\n.standard-card {\r\n  background: var(--bg-secondary);\r\n  border-radius: var(--border-radius);\r\n  padding: 1.5rem;\r\n  transition: var(--transition);\r\n  border: 1px solid rgba(172, 203, 195, 0.2);\r\n}\r\n\r\n.standard-card:hover {\r\n  transform: translateY(-2px);\r\n  border-color: rgba(7, 255, 169, 0.4);\r\n  box-shadow: 0 4px 15px rgba(7, 255, 169, 0.15);\r\n}\r\n\r\n.standard-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.standard-header h4 {\r\n  font-size: 1rem;\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n  margin: 0;\r\n}\r\n\r\n.score {\r\n  font-size: 1.25rem;\r\n  font-weight: 700;\r\n  color: var(--secondary-color);\r\n}\r\n\r\n.progress-bar {\r\n  width: 100%;\r\n  height: 8px;\r\n  background: var(--bg-tertiary);\r\n  border-radius: 4px;\r\n  overflow: hidden;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.progress-fill {\r\n  height: 100%;\r\n  background: var(--gradient-secondary);\r\n  border-radius: 4px;\r\n  transition: width 1s ease-in-out;\r\n}\r\n\r\n.standard-metrics {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  gap: 1rem;\r\n}\r\n\r\n.metric {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  text-align: center;\r\n}\r\n\r\n.metric-label {\r\n  font-size: 0.75rem;\r\n  color: var(--text-secondary);\r\n  margin-bottom: 0.25rem;\r\n}\r\n\r\n.metric-value {\r\n  font-size: 1rem;\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n}\r\n\r\n/* Responsive Design */\r\n@media (max-width: 768px) {\r\n  .assessment-score-page {\r\n    padding: 0.5rem;\r\n  }\r\n  \r\n  .assessment-header h1 {\r\n    font-size: 2rem;\r\n  }\r\n  \r\n  .tab-navigation {\r\n    flex-wrap: wrap;\r\n    gap: 0.25rem;\r\n  }\r\n  \r\n  .tab-button {\r\n    padding: 0.5rem 1rem;\r\n    font-size: 0.875rem;\r\n  }\r\n  \r\n  .assessment-grid {\r\n    grid-template-columns: 1fr;\r\n    gap: 1rem;\r\n  }\r\n  \r\n  .main-score {\r\n    grid-column: span 1;\r\n  }\r\n  \r\n  .objectives-grid,\r\n  .control-stats {\r\n    flex-direction: column;\r\n  }\r\n  \r\n  .stat-card {\r\n    min-width: 100%;\r\n  }\r\n  \r\n  .standards-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n  \r\n  .bars {\r\n    gap: 0.5rem;\r\n  }\r\n  \r\n  .bar-label {\r\n    font-size: 0.625rem;\r\n    max-width: 60px;\r\n  }\r\n  \r\n  .bar-chart-enhanced {\r\n    gap: 0.5rem;\r\n    padding: 0.5rem;\r\n  }\r\n  \r\n  .y-axis-labels {\r\n    min-width: 40px;\r\n    padding-right: 0.5rem;\r\n  }\r\n  \r\n  .y-axis-label {\r\n    font-size: 0.65rem;\r\n  }\r\n  \r\n  .bars-enhanced {\r\n    gap: 0.75rem;\r\n  }\r\n  \r\n  .bar-enhanced {\r\n    max-width: 60px;\r\n    min-width: 40px;\r\n  }\r\n  \r\n  .bar-label-enhanced {\r\n    font-size: 0.7rem;\r\n  }\r\n  \r\n  .bar-value-enhanced {\r\n    font-size: 0.75rem;\r\n    padding: 0.2rem 0.4rem;\r\n    top: -24px;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .assessment-header h1 {\r\n    font-size: 1.75rem;\r\n  }\r\n  \r\n  .assessment-header p {\r\n    font-size: 1rem;\r\n  }\r\n  \r\n  .score-card {\r\n    padding: 1.5rem;\r\n  }\r\n  \r\n  .objective-card,\r\n  .standard-card {\r\n    padding: 1rem;\r\n  }\r\n  \r\n  .bar-label {\r\n    font-size: 0.5rem;\r\n    max-width: 50px;\r\n  }\r\n  \r\n  .bar-chart-enhanced {\r\n    flex-direction: column;\r\n    gap: 0.5rem;\r\n    padding: 0.5rem;\r\n  }\r\n  \r\n  .y-axis-labels {\r\n    flex-direction: row;\r\n    justify-content: space-between;\r\n    width: 100%;\r\n    min-width: auto;\r\n    padding-right: 0;\r\n    padding-bottom: 0.5rem;\r\n    height: auto;\r\n  }\r\n  \r\n  .y-axis-label {\r\n    font-size: 0.6rem;\r\n  }\r\n  \r\n  .chart-area {\r\n    width: 100%;\r\n  }\r\n  \r\n  .bars-enhanced {\r\n    gap: 0.5rem;\r\n  }\r\n  \r\n  .bar-enhanced {\r\n    max-width: 50px;\r\n    min-width: 35px;\r\n  }\r\n  \r\n  .bar-label-enhanced {\r\n    font-size: 0.65rem;\r\n  }\r\n  \r\n  .bar-value-enhanced {\r\n    font-size: 0.7rem;\r\n    padding: 0.15rem 0.3rem;\r\n    top: -22px;\r\n  }\r\n  \r\n  .line-chart-enhanced {\r\n    gap: 0.5rem;\r\n    padding: 0.5rem;\r\n  }\r\n  \r\n  .y-axis-labels-line {\r\n    min-width: 40px;\r\n    padding-right: 0.5rem;\r\n  }\r\n  \r\n  .y-axis-label-line {\r\n    font-size: 0.65rem;\r\n  }\r\n  \r\n  .line-label-enhanced {\r\n    font-size: 0.7rem;\r\n  }\r\n}\r\n\r\n/* Professional Government-Appropriate Animations */\r\n@keyframes fadeInUp {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(30px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n@keyframes slideInFromLeft {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateX(-30px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateX(0);\r\n  }\r\n}\r\n\r\n@keyframes slideInFromRight {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateX(30px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateX(0);\r\n  }\r\n}\r\n\r\n@keyframes scaleIn {\r\n  from {\r\n    opacity: 0;\r\n    transform: scale(0.8);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: scale(1);\r\n  }\r\n}\r\n\r\n/* Smooth Donut Chart Progress Animation */\r\n@keyframes drawProgress {\r\n  from {\r\n    stroke-dasharray: 0 1000;\r\n  }\r\n  to {\r\n    stroke-dasharray: var(--progress-dasharray);\r\n  }\r\n}\r\n\r\n/* Smooth Bar Chart Growth Animation */\r\n@keyframes growBar {\r\n  from {\r\n    height: 0;\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    height: var(--bar-height);\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n/* Smooth Line Chart Drawing Animation */\r\n@keyframes drawLine {\r\n  from {\r\n    stroke-dashoffset: 1000;\r\n  }\r\n  to {\r\n    stroke-dashoffset: 0;\r\n  }\r\n}\r\n\r\n/* Smooth Radar Chart Drawing Animation */\r\n@keyframes drawRadar {\r\n  from {\r\n    stroke-dasharray: 0 1000;\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    stroke-dasharray: 1000 0;\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n/* Smooth Pulse Animation for Data Points */\r\n@keyframes pulseIn {\r\n  0% {\r\n    opacity: 0;\r\n    transform: scale(0.3);\r\n  }\r\n  50% {\r\n    opacity: 0.8;\r\n    transform: scale(1.1);\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n    transform: scale(1);\r\n  }\r\n}\r\n\r\n/* Professional Stagger Animation */\r\n@keyframes staggerIn {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(20px) scale(0.95);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0) scale(1);\r\n  }\r\n}\r\n\r\n/* Card Animations */\r\n.score-card,\r\n.objective-card,\r\n.standard-card,\r\n.stat-card {\r\n  animation: fadeInUp 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);\r\n}\r\n\r\n.tab-button {\r\n  animation: slideInFromLeft 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94);\r\n}\r\n\r\n/* Professional Chart Animations */\r\n.donut-chart svg circle:last-child {\r\n  animation: drawProgress 2.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;\r\n}\r\n\r\n.bar {\r\n  animation: growBar 1.2s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;\r\n  animation-delay: var(--bar-delay, 0s);\r\n}\r\n\r\n.line-chart polyline {\r\n  animation: drawLine 2s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;\r\n}\r\n\r\n.radar-chart polygon {\r\n  animation: drawRadar 1.8s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;\r\n}\r\n\r\n.radar-chart circle {\r\n  animation: pulseIn 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;\r\n  animation-delay: var(--point-delay, 0s);\r\n}\r\n\r\n/* Professional Hover Effects */\r\n.bar:hover {\r\n  transform: scale(1.02) translateY(-2px);\r\n  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);\r\n}\r\n\r\n.bar:hover .bar-value {\r\n  transform: scale(1.05) translateY(-2px);\r\n  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);\r\n}\r\n\r\n.score-card:hover,\r\n.objective-card:hover,\r\n.standard-card:hover {\r\n  transform: translateY(-4px) scale(1.01);\r\n  transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);\r\n}\r\n\r\n/* Staggered Animation for Multiple Elements */\r\n.bar-group:nth-child(1) { --bar-delay: 0.1s; }\r\n.bar-group:nth-child(2) { --bar-delay: 0.2s; }\r\n.bar-group:nth-child(3) { --bar-delay: 0.3s; }\r\n.bar-group:nth-child(4) { --bar-delay: 0.4s; }\r\n.bar-group:nth-child(5) { --bar-delay: 0.5s; }\r\n\r\n.radar-chart circle:nth-child(1) { --point-delay: 0.2s; }\r\n.radar-chart circle:nth-child(2) { --point-delay: 0.4s; }\r\n.radar-chart circle:nth-child(3) { --point-delay: 0.6s; }\r\n.radar-chart circle:nth-child(4) { --point-delay: 0.8s; }\r\n.radar-chart circle:nth-child(5) { --point-delay: 1s; }\r\n.radar-chart circle:nth-child(6) { --point-delay: 1.2s; }\r\n\r\n/* Custom scrollbar */\r\n.assessment-score-page::-webkit-scrollbar {\r\n  width: 8px;\r\n}\r\n\r\n.assessment-score-page::-webkit-scrollbar-track {\r\n  background: var(--bg-tertiary);\r\n  border-radius: 4px;\r\n}\r\n\r\n.assessment-score-page::-webkit-scrollbar-thumb {\r\n  background: #1f7c50;\r\n  border-radius: 4px;\r\n}\r\n\r\n.assessment-score-page::-webkit-scrollbar-thumb:hover {\r\n  background: #07ffa9;\r\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
